export default __webpack_public_path__ + "static/src/assets/images/icons/trade_icon_cancel_disable.png";